export default __webpack_public_path__ + "static/media/4.bf9b40c2.jpg";